import { getTokenLocal } from "utils/localStorage.util";
import ApiRoutes from "../configs/endpoints.config";
import HttpClient from "./index.api";
const baseURL = process.env.REACT_APP_API_URL;

class PropertyApi extends HttpClient {
  constructor() {
    super(baseURL);
    this._initializeRequestInterceptor();
    this._initializeResponseInterceptor();
  }

  _initializeRequestInterceptor = () => {
    this.instance.interceptors.request.use((config) => {
      config.headers["Authorization"] = `Bearer ${getTokenLocal()}`;
      config.headers["ngrok-skip-browser-warning"] = "true";
      return config;
    });
  };

  _initializeResponseInterceptor = () => {
    this.instance.interceptors.response.use(
      (response) => {
        return response;
      },
      (response) => {
        return Promise.resolve(response);
      }
    );
  };

  AllPropertyConfig = ApiRoutes.Properties.AllProperties;
  GetPropertyDetailsConfig = ApiRoutes.Properties.GetPropertyDetails;
  GetPropertyReportsConfig = ApiRoutes.Properties.GetPropertyReports;
  UpdatePropertyReportStatusConfig = ApiRoutes.Properties.UpdatePropertyReportStatus;
  ToggleBlockPropertyConfig = ApiRoutes.Properties.ToggleBlockProperty;
  DeletePropertyByAdminConfig = ApiRoutes.Properties.DeletePropertyByAdmin;

  allProperties = async () => {
    return this.instance({
      method: this.AllPropertyConfig.Method,
      url: this.AllPropertyConfig.Endpoint,
    });
  };

  getPropertyReports = async () => {
    return this.instance({
      method: this.GetPropertyReportsConfig.Method,
      url: this.GetPropertyReportsConfig.Endpoint,
    });
  };

 deletePropertyByAdmin = async (propertyId, reason) => {
  return this.instance({
    method: this.DeletePropertyByAdminConfig.Method,
    url: this.DeletePropertyByAdminConfig.Endpoint(propertyId),
    data: {
      reason
    }
  });
};

  getPropertyDetails = async (propertyId) => {
    return this.instance({
      method: this.GetPropertyDetailsConfig.Method,
      url: this.GetPropertyDetailsConfig.Endpoint(propertyId),
      headers: {},
    });
  };

  updatePropertyReportStatus = async (data) => {
    return this.instance({
      method: this.UpdatePropertyReportStatusConfig.Method,
      url: this.UpdatePropertyReportStatusConfig.Endpoint,
      data,
    });
  };


  toggleBlockProperty = async ({ propertyId }) => {
    return this.instance({
      method: this.ToggleBlockPropertyConfig.Method,
      url: this.ToggleBlockPropertyConfig.Endpoint(propertyId),
    });
  };

}

export default PropertyApi;
